module.exports = __webpack_public_path__ + "assets/img/xlwy_1.d0110b78.png";